var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"contentPortal"},[_c('v-card',[_c('v-card-title',{staticClass:"color-title"},[_c('h1',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t('category')))])]),_c('Addcategory',{ref:"Addcategory"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }